import React, { useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Button,
    InputLabel,
    CircularProgress,
    TextField,
    Modal,

} from "@mui/material";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { useUserAdmin } from "../../../../admin/UserContext";
import { IoClose } from "react-icons/io5";

export const CrearIcono = ({ onclose, fetchSliders }) => {
    const { Token } = useUserAdmin();
    const [loading, setLoading] = useState(false);
    const backendURL = process.env.REACT_APP_BACKEND_URL;
    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [enviandoAlert, setEnviandoAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [formData, setFormData] = useState({
        imagen:null,
        titulo1: "",
        titulo2: "",
        posicion:''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };
    const handleFileChange = (e, field) => {
        const file = e.target.files[0];
        setFormData({ ...formData, [field]: file });
    };




    const handleSubmit = async (e) => {
        e.preventDefault();
        setEnviandoAlert(true)
        const data = new FormData();
         data.append("imagen", formData.imagen);
        data.append("titulo1", formData.titulo1);
        data.append("titulo2", formData.titulo2);
        data.append("posicion", formData.posicion);



        try {
            setLoading(true);
            await axios.post(`${backendURL}/api/crear/icono`, data, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                    "Content-Type": "multipart/form-data"
                }
            });

            setAlertMessage("Se ha generado con éxito.");
            setEnviandoAlert(false)
            setSuccessAlertOpen(true);


        } catch (error) {
            console.error(error);
            setAlertMessage("Error al crear.");
            setErrorAlertOpen(true);
            setEnviandoAlert(false)
        } finally {
            setLoading(false);
            await fetchSliders()
            setTimeout(() => {
                setSuccessAlertOpen(false);
                setEnviandoAlert(false)
                setErrorAlertOpen(false);
                onclose();

            }, 3000);
        }
    };


    const renderPreview = (file) => {
        return file ? (
            <img
                src={URL.createObjectURL(file)}
                alt="preview"
                style={{
                    width: "100%",
                    maxWidth: "250px",
                    height: "auto",
                    marginBottom: "10px",
                    borderRadius: "8px",
                    border: "2px solid #585857"
                }}
            />
        ) : null;
    };

    return (
        <Box p={3}>
            <Typography variant="h5" gutterBottom sx={{ color: "#585857" }}>
                Crear Icono Jofemar
            </Typography>

            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Imagen </InputLabel>
                    {renderPreview(formData.imagen)}
                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleFileChange(e, "imagen")}
                        style={{ border: "2px solid #585857", padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>

                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Titulo1</InputLabel>

                    <input
                        name="titulo1"
                        label="Título"
                        value={formData.titulo1}
                        onChange={handleInputChange}
                        style={{ border: "2px solid #585857", color: '#585857', background: '#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Titulo2</InputLabel>

                    <input
                        name="titulo2"
                        label="Título"
                        value={formData.titulo2}
                        onChange={handleInputChange}
                        style={{ border: "2px solid #585857", color: '#585857', background: '#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
                <div style={{ width: '100%' }}>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Posicion</InputLabel>
                    <TextField
                        label="posicion"
                        type="number"
                        name="posicion"
                        value={formData.posicion}
                        onChange={handleInputChange}
                        inputProps={{ min: 1 }}
                        sx={{
                            width: '100%',
                            '& .MuiInputBase-input': {
                                color: '#585857', // Color del número (input)
                            },
                            '& .MuiInputLabel-root': {
                                color: '#585857', // Color del label
                            },
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    color: '#585857',
                                    borderColor: '#585857'
                                },
                                '&:hover fieldset': {
                                    borderColor: '#585857'
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#585857'
                                }
                            }
                        }}
                    />
                </div>
                <Button
                    variant="contained"
                    disabled={loading}
                    sx={{
                        backgroundColor: "#5E487B",
                        color: "#fff",
                        textTransform: "capitalize"
                    }}
                    type="submit"
                >    {loading ? <CircularProgress size={24} /> : 'Guardar portada'}

                </Button>
            </form>
            <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                        <IoClose style={{ color: '#585857' }} />
                    </section>
                    <section style={{ textAlign: 'center' }}>
                        <FaRegCircleCheck style={{ color: 'green', fontSize: '2rem', marginBottom: '1rem' }} />
                        <p>{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            {/* Modal de error */}
            <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: 'center' }}>
                        <BiErrorCircle style={{ color: 'red', fontSize: '2rem', marginBottom: '1rem' }} />
                        <p>{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            {/* Modal de progreso */}
            <Modal open={enviandoAlert} onClose={() => setEnviandoAlert(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: 'center', padding: '1rem' }}>
                        <CircularProgress style={{ color: '#694B81' }} />
                        <p>Procesando solicitud...</p>
                    </section>
                </Box>
            </Modal>
        </Box>
    );
};

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#ffff',
    border: '0px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius: '10px'
};
